import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { Ng2CarouselamosModule } from 'ng2-carouselamos';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSortModule, MatTableModule
} from "@angular/material";

//custom modules
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { ProfileComponent } from './profile/profile.component';
import { ProgramDetailComponent } from './program-detail/program-detail.component';
import { ModuleListComponent } from './module-list/module-list.component';
import { ResourceDetailComponent } from './resource-detail/resource-detail.component';
import { ActivityDetailComponent } from './activity-detail/activity-detail.component';
import { ProgramListComponent } from './program-list/program-list.component';
import { ResourceStripComponent, NgbdModal2Content } from './resource-strip/resource-strip.component';
import { ModuleCommentsComponent } from './module-comments/module-comments.component';
import { AdminComponent } from './admin/admin.component';
import { UserListComponent } from './user-list/user-list.component';
import { SessionListComponent } from './session-list/session-list.component';
import { ReportListComponent } from './report-list/report-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { LogoutComponent } from './logout/logout.component';
import { RememberPasswordComponent } from './remember-password/remember-password.component';

//services
import { ContentfulService } from './contentful.service';
import { FileService } from './file.service';
import { VimeoService } from './vimeo.service';
import { ApiOpenmindService } from './apiopenmind.service';

//add custom providers
import { WINDOW_PROVIDERS } from './WindowProviders';



@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    FooterComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    ProfileComponent,
    ProgramDetailComponent,
    ModuleListComponent,
    ResourceDetailComponent,
    ActivityDetailComponent,
    ProgramListComponent,
    ResourceStripComponent,
    ModuleCommentsComponent,
    NgbdModal2Content,
    AdminComponent,
    UserListComponent,
    SessionListComponent,
    ReportListComponent,
    UserDetailComponent,
    LogoutComponent,
    RememberPasswordComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    //HttpModule,
    FormsModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'program-detail', component: ProgramDetailComponent },
      { path: 'program-detail/:programName', component: ProgramDetailComponent },
      { path: 'module-list', component: ModuleListComponent },
      { path: 'module-list/:moduleName', component: ModuleListComponent },
      { path: 'resource-detail', component: ResourceDetailComponent },
      { path: 'activity-detail', component: ActivityDetailComponent },
      { path: 'rememberpassword', component: RememberPasswordComponent },
      { path: 'program-list', component: ProgramListComponent },
      { path: 'resource-strip', component: ResourceStripComponent },
      { path: 'module-comments', component: ModuleCommentsComponent },
      { path: 'admin', component: AdminComponent },
      { path: 'user-list', component: UserListComponent },
      { path: 'session-list', component: SessionListComponent },
      { path: 'report-list', component: ReportListComponent },
      { path: 'user-detail', component: UserDetailComponent },
      { path: 'logout', component: LogoutComponent },
      { path: '**', redirectTo:'' },
    ]),
    Ng2CarouselamosModule,
    NgbModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule
  ],
  providers: [ContentfulService, FileService, ApiOpenmindService, WINDOW_PROVIDERS],
  bootstrap: [AppComponent],
  entryComponents: [NgbdModal2Content]
})
export class AppModule { }
